/* Copyright 2013 - 2022 Waiterio LLC */
export default '#d9534f'
